module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-wrapper",
    style: ({
      'background-image': 'url(' + require('../assets/img/background@3x.png') + ')'
    })
  }, [_vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-content"
  }, [_c('div', {
    staticClass: "homeContainer"
  }, [_c('div', {
    staticClass: "firstRow"
  }, [_c('div', {
    staticClass: "contentContainer"
  }, [_c('div', {
    staticClass: "textContainer"
  }, [_c('h1', {
    staticClass: "text1"
  }, [_vm._v("THE"), _c('br'), _vm._v("BLOCKCHAIN SERIES")]), _vm._v(" "), _c('h1', {
    staticClass: "text2"
  }, [_vm._v("Chronoswiss luxury watches for an everlasting legacy")]), _vm._v(" "), _c('h1', {
    staticClass: "text3"
  }, [_vm._v("Claim ownership and activate warranty of your Chronoswiss luxury watch registered by LuxTag on the NEM Blockchain.")]), _vm._v(" "), _c('h1', {
    staticClass: "text3"
  }, [_vm._v("Be the proud owner of the first crypto luxury watches, registered on the NEM Blockchain.")]), _vm._v(" "), _c('h1', {
    staticClass: "text2"
  }, [_vm._v("Proof of Ownership")]), _vm._v(" "), _c('h1', {
    staticClass: "text3"
  }, [_vm._v("Through the LuxTag WebApp, customers are able to claim the ownership of the watches using the unique QR code on the warranty card. Furthermore, customers can appreciate the fine details of their very own watches in the assets tab, as well as transfer the ownership to a second buyer.")]), _vm._v(" "), _c('h1', {
    staticClass: "text2"
  }, [_vm._v("Proof of Origin")]), _vm._v(" "), _c('h1', {
    staticClass: "text3"
  }, [_vm._v("The LuxTag WebApp enables customers to view the history of the watches, previous owners, and the watches servicing history. Additionally, customers can record notes about the assets for future references. The recorded provenance enhances the value of the watches through generations.")])]), _vm._v(" "), _c('div', {
    staticClass: "buttonsContainer"
  }, [_c('a', {
    staticClass: "button",
    attrs: {
      "href": "https://bit.ly/luxtag-ios",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "home-logo",
    attrs: {
      "src": require("../assets/img/apple-store-button@3x.png")
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "button",
    attrs: {
      "href": "https://bit.ly/luxtag-android",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "home-logo",
    attrs: {
      "src": require("../assets/img/google-play-button@3x.png")
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "imageContainer"
  }, [_c('img', {
    staticClass: "home-image",
    attrs: {
      "src": require("../assets/img/btc_series.png")
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a5296072","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 1151
// module chunks = 5